document.documentElement.classList.remove('no-js');

function formatMoney(cents, format) {
  const value = Number(cents || 0);
  const formatString = format || '€{{amount_with_comma_separator}}';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatWithDelimiters = (number, precision = 2, thousands = '.', decimal = ',') => {
    const fixed = (number / 100).toFixed(precision);
    const parts = fixed.split('.');
    const euros = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
    return `${euros}${precision ? decimal + parts[1] : ''}`;
  };
  const match = formatString.match(placeholderRegex);
  if (!match) return formatString;
  const replacement = match[1].includes('no_decimals')
    ? formatWithDelimiters(value, 0, '.', ',')
    : formatWithDelimiters(value, 2, '.', ',');
  return formatString.replace(placeholderRegex, replacement);
}

customElements.define('ht-menu', class extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-menu-toggle]');
    this.panel = this.querySelector('[data-menu-panel]');
    if (!this.button || !this.panel) return;
    this.button.addEventListener('click', () => {
      const expanded = this.button.getAttribute('aria-expanded') === 'true';
      this.button.setAttribute('aria-expanded', String(!expanded));
      this.panel.toggleAttribute('hidden', expanded);
      document.body.classList.toggle('menu-open', !expanded);
    });
  }
});

customElements.define('variant-selects', class extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', () => this.onVariantChange());
    this.onVariantChange();
  }

  onVariantChange() {
    const form = this.closest('form');
    const idInput = form && form.querySelector('[data-variant-id]');
    const json = this.querySelector('[data-variant-json]');
    if (!idInput || !json) return;
    const options = Array.from(this.querySelectorAll('select')).map((select) => select.value);
    const variants = JSON.parse(json.textContent);
    const variant = variants.find((item) => item.options.every((option, index) => option === options[index]));
    const section = this.closest('[data-section-id]') || document;
    const button = form.querySelector('[data-add-to-cart]');
    const buttonText = form.querySelector('[data-add-to-cart-text]');
    const price = section.querySelector('[data-product-price]');
    const comparePrice = section.querySelector('[data-compare-price]');
    const badge = section.querySelector('[data-discount-badge]');
    const availability = section.querySelector('[data-availability]');
    const sku = section.querySelector('[data-sku]');
    const skuWrapper = section.querySelector('[data-sku-wrapper]');
    const moneyFormat = this.dataset.moneyFormat || section.querySelector('[data-price-wrapper]')?.dataset.moneyFormat;

    if (!variant) {
      idInput.value = '';
      if (button) button.disabled = true;
      if (buttonText) buttonText.textContent = 'Nicht verfügbar';
      if (availability) {
        availability.textContent = 'Nicht verfügbar';
        availability.className = 'is-sold-out';
      }
      return;
    }

    idInput.value = variant.id;

    if (price) price.textContent = formatMoney(variant.price, moneyFormat);
    if (comparePrice && badge) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        comparePrice.textContent = formatMoney(variant.compare_at_price, moneyFormat);
        comparePrice.classList.remove('is-hidden');
        badge.textContent = `Spare ${formatMoney(variant.compare_at_price - variant.price, moneyFormat)}`;
        badge.classList.remove('is-hidden');
      } else {
        comparePrice.textContent = '';
        comparePrice.classList.add('is-hidden');
        badge.textContent = '';
        badge.classList.add('is-hidden');
      }
    }
    if (availability) {
      availability.textContent = variant.available ? 'Verfügbar' : 'Ausverkauft';
      availability.className = variant.available ? 'is-available' : 'is-sold-out';
    }
    if (sku && skuWrapper) {
      sku.textContent = variant.sku || '';
      skuWrapper.hidden = !variant.sku;
    }
    if (button) button.disabled = !variant.available;
    if (buttonText) buttonText.textContent = variant.available ? 'In den Warenkorb' : 'Ausverkauft';
    this.updateVariantMedia(section, variant, options);
  }

  updateVariantMedia(section, variant, selectedOptions) {
    const gallery = section.querySelector('[data-product-gallery]');
    if (!gallery) return;

    const mediaItems = Array.from(gallery.querySelectorAll('[data-product-media]'));
    if (!mediaItems.length) return;

    const normalizedOptions = selectedOptions.map((option) => String(option || '').trim().toLowerCase()).filter(Boolean);
    let visibleCount = 0;

    mediaItems.forEach((item) => {
      const tags = String(item.dataset.mediaOptionTags || '')
        .split('||')
        .map((tag) => tag.trim().toLowerCase())
        .filter(Boolean);

      const isGeneralImage = tags.length === 0;
      const matchesSelectedOption = tags.some((tag) => normalizedOptions.includes(tag));
      const shouldShow = isGeneralImage || matchesSelectedOption;

      item.classList.toggle('is-hidden', !shouldShow);
      item.classList.remove('is-active');
      if (shouldShow) visibleCount += 1;
    });

    if (!visibleCount) {
      mediaItems.forEach((item) => item.classList.remove('is-hidden'));
    }

    const mediaId = this.getVariantMediaId(variant);
    const activeItem = mediaId && gallery.querySelector(`[data-media-id="${mediaId}"]`);
    const fallbackItem = gallery.querySelector('[data-product-media]:not(.is-hidden)');
    const targetItem = activeItem || fallbackItem;

    if (targetItem) {
      targetItem.classList.remove('is-hidden');
      targetItem.classList.add('is-active');
      if (window.matchMedia('(max-width: 989px)').matches) {
        targetItem.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }
  }

  getVariantMediaId(variant) {
    if (!variant) return null;
    if (variant.featured_media && variant.featured_media.id) return String(variant.featured_media.id);
    if (variant.featured_image && variant.featured_image.id) return String(variant.featured_image.id);
    if (variant.image && variant.image.id) return String(variant.image.id);
    return null;
  }
});
